<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{$t("operaciones_rappel_mensual.titulo")}}</h1>
      <div class="toolbar">
      </div>
    </div>

    <DxDataGrid v-bind="getDefaultGridProperties()" :data-source="gridSource" ref="grid" class="dx-card wide-card grid-liquidaciones">
      <DxColumn data-field="CodigoSecuencial" :caption="$t('liquidaciones.grid.id')" format="0000000000"></DxColumn>
      <DxColumn data-field="FechaActivacion" :caption="$t('liquidaciones.grid.fecha_activacion')" data-type="date" format="dd/MM/yyyy"></DxColumn>
      <DxColumn data-field="DocumentoTitular" :caption="$t('liquidaciones.grid.documento_cliente')"></DxColumn>
      <DxColumn data-field="DireccionTitular" :caption="$t('liquidaciones.grid.direccion_cliente')"></DxColumn>
      <DxColumn data-field="IdTipoSuministro" :caption="$t('operaciones.grid.suministro')">
        <DxLookup column-auto-width="true" v-bind="getLookup('rappels_mensuales', 'tipo_suministro')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="Cups" :caption="$t('operaciones.grid.cups')"></DxColumn>
      <DxColumn type="buttons" :caption="$t('liquidaciones.grid.acciones')" :fixed="true" fixed-position="right" width="100px" :buttons="[
        {
          cssClass: 'btn btn-link text-decoration-none btn-sm',
          text: $t('liquidaciones.grid.ver_detalle'),
          icon: 'fa-solid fa-magnifying-glass text-success',
          onClick: (e: any) => verDetalle(e)
        }
      ]" />
      <DxColumnFixing :enabled="true" />
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { useApi } from "@api/integration";
import {
  DxDataGrid,
  DxColumnFixing,
  DxColumn,
  DxLookup
} from "devextreme-vue/data-grid";
import {
  getDefaultGridProperties,
  getLookup
} from "@helpers/grid-helper";
import type CustomStore from "devextreme/data/custom_store";
import { onMounted, ref } from "vue";
import type DevExpress from "devextreme";
import type { DXLoadOptions } from "@/.shared/.api";
import { TipoOperacionEnum } from "@/.shared/enums/TipoOperacionEnum";
import { useRouter } from "@/.shared/services/routing-services";

const props = defineProps(["IdRappelMensual"]);
const api = useApi();
const gridSource = ref<CustomStore>();
const grid = ref<DxDataGrid>();
const router = useRouter();

onMounted(async () => {

  gridSource.value = api.apiStore({
    key: "IdTramite",
    load: async (p) => {
      const q = p as DXLoadOptions;
      
      if (q.filter != null && q.filter.length >= 0)
        q.filter = [["IdRappelMensual", "=", props.IdRappelMensual], "and", q.filter];
      else
        q.filter = ["IdRappelMensual", "=", props.IdRappelMensual];

      return await api.callStandardApi("getTramitesEnergiaRappelMensualForGrid", { showLoading: false }, q)
    }
  });
  
});

async function verDetalle(data: DevExpress.ui.dxDataGrid.ColumnButtonClickEvent) {
  const route = router.resolve({ name: "tramite", query: { idOperacion: data.row?.data.IdOperacion, tipoOperacion: TipoOperacionEnum.Energia } });
  window.open(route.href, '_blank');
}

</script>

<style lang="scss" scoped>


</style>
